import { useIsMobile } from '@/hooks/use-is-mobile'
import { useTabNotificationEvents } from '@/hooks/use-tab-notification-events'
import { createContext, useContext } from 'react'
import { Outlet } from 'react-router-dom'

const MobileContext = createContext(false)

export function useIsMobileContext() {
  return useContext(MobileContext)
}

export function ResponsiveLayout() {
  const isMobile = useIsMobile()
  useTabNotificationEvents()

  return (
    <MobileContext.Provider value={isMobile}>
      <Outlet />
    </MobileContext.Provider>
  )
}
